import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const fieldWidth = 250;

export const InstructionFieldStyles = css`
  width: ${fieldWidth}px;
  background-color: ${theme.colors.white};
`;
